// Mobile-number gate (docs/SIGNUP.md). While sign-up asks for a verified mobile, /api/auth/me marks
// an account without one `phoneRequired`; every app page's auth gate sends it to /verify-mobile,
// which brings it back here afterwards. Admin pages do not call this, so the owner can always reach
// Admin Settings to turn the setting off.
//
// Not while an admin is logged in as this user ("Log in as"): /verify-mobile has no Exit banner, so
// the admin would be stranded on it, and they could not verify somebody else's mobile anyway (account
// changes are refused). The banner already tells them whose account this is.
export function sendToVerifyMobile(user, loc = window.location) {
  if (!user || !user.phoneRequired || user.impersonatedBy) return false;
  loc.replace(`/verify-mobile?return=${encodeURIComponent(loc.pathname + loc.search)}`);
  return true;
}
